import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';
import { BookingModel } from './classes';

const RemovePlayer = (bookingId, playerId) => {
  const url = `${apiConstants.RemovePlayer}?BookingId=${bookingId}&PlayerId=${playerId}&Manual=true`;

  return httpClient.delete(url).then(result => result);
};

const CancelBooking = (bookingId) => {
  const url = `${apiConstants.Cancel}`;

  return httpClient.post(url, {
    bookingId,
  }).then(result => result);
};


const CreateBooking = (courseId, teeSlotTime, players) => {
  const url = apiConstants.Create;

  players.forEach((player) => {
    player.address1 = '';
    player.address2 = '';
    player.city = '';
    player.postCode = '';
    player.teeSlotTime = teeSlotTime;
  });

  const booking = new BookingModel(courseId, players);
  return httpClient.post(url, booking).then(result => result.data.result.items);
};

export { CreateBooking, RemovePlayer, CancelBooking };
